import './Footer.css';
import React, {useEffect, useState} from 'react';
import {getInformation, getItems, findInfoValue} from '../api';

const Footer = () => {
  const [informationData, setInformationData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    getInformation()
      .then((response) => {
        setInformationData(getItems(response));
        setLoading(false);
      })
      .catch(() => {
        setError('Footer 데이터를 가져오는 데 실패했습니다.');
        setLoading(false);
      });
  }, []);

  const valueOf = (key) => findInfoValue(informationData, key, '미등록');

  if (loading) return <div>Loading footer...</div>;
  if (error) return <div>{error}</div>;

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-container-left">
          <div className="company-name">{valueOf('company_name')}</div>
        </div>
        <div className="footer-container-right">
          <div className="footer-info">
            <span>사업자번호: {valueOf('business_number')}</span>
            <span>대표이사: {valueOf('ceo_name')}</span>
            <span>주소: {valueOf('address')}</span>
            <span>대표전화: {valueOf('phone')}</span>
            <span>FAX: {valueOf('fax')}</span>
            <p className="footer-copyright">
              Copyright © {new Date().getFullYear()} {valueOf('company_name')} ALL RIGHTS RESERVED
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
